/**
 * The report's view controls: back to the default view, and print. A viewer's map adjustments
 * are theirs alone and live in their browser.
 */
import { Button, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export interface ReportOptionsPanelProps {
  onReset: () => void;
  onPrint: () => void;
}

export function ReportOptionsPanel({ onReset, onPrint }: ReportOptionsPanelProps) {
  const { t } = useTranslation('reports');
  return (
    <Group gap="xs" wrap="nowrap" className="report-options">
      <Button size="xs" variant="subtle" onClick={onReset}>
        {t('options.reset')}
      </Button>
      <Button size="xs" variant="default" onClick={onPrint}>
        {t('page.print')}
      </Button>
    </Group>
  );
}
